<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-body">
          <div class="form">
            <div class="row">
              <div class="modal-toolbar col-xs-12">
                <div class="col-xs-9">
                  <span class="modal__heading">{{ headingText }}</span>
                </div>
                <div class="col-xs-3">
                  <a href="#" @click.prevent="$emit('close')" class="modal__close pull-right">
                    <span class="glyphicon glyphicon-remove-circle" aria-hidden="true"></span>
                  </a>
                </div>
              </div>
            </div>
            <slot name="form" />
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppModal",
  props: {
    headingText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss">
.modal-toolbar {
  padding-bottom: 15px;
  padding-left: 0;
  padding-right: 0;
  border-bottom: 1px solid #e7e7e7;
}
.modal {
  &__heading {
    font-size: 13px;
    color: #545354;
  }

  &__button {
    font-size: 14px;
    color: #ffffff;
    border: none;
    outline: none;
    border-radius: 2px;
    padding: 9px 15px;
    cursor: pointer;
    margin-top: 14px;
    font-weight: 600;
  }

  &__close {
    color: #545354;
  }
}

.form {
  font-size: 13px;
  font-weight: 600;

  &__email {
    padding-top: 15px;
  }

  &__field {
    margin: 9px 0;
  }

  &__checkbox {
    margin-top: 9px;
    margin-right: 5px;
  }

  &__input {
    width: 100%;
    border-radius: 19px;
    border: 1px solid #e7e7e7;
    color: #545354;
    padding: 9px 15px;
  }
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;

}

.modal-container {
  max-width: 500px;
  margin: 0px auto;
  padding: 13px 15px 9px 15px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);

  @media (max-width: 768px) {
    max-width: 90%;;
  }
}

.modal-default-button {
  float: right;
}
</style>




// WEBPACK FOOTER //
// src/components/layout/AppModal.vue